import React from 'react'
import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

export const FormMicSample = (props) => {

    const {
        handleInputChange, name, validaciones,
    } = props;

    const {
        name_valid,
    } = validaciones;

    return (
        <Form className="" role="form">

            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre de la muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="name"
                            value={name}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={name_valid}
                            className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>


        </Form>
    )
}
